import { render } from "./halfCircleIcon.svg?vue&type=template&id=17ef4131"
const script = {}
script.render = render

export default script